import { createRoutine } from "@rentiohq/shared-frontend/dist/redux/utils/routine.utils";
import { createAction } from "redux-act";
export var getRemotePreferences = createRoutine("GET_REMOTE_PREFERENCES");
export var setPreferences = createAction("SET_PREFERENCES");
export var getIndexLastModified = createRoutine("GET_INDEX_LAST_MODIFIED");
